import {
  FORGET_PARTICIPANT_PASSWORD,
  FORGET_PARTICIPANT_PASSWORD_SUCCESS,
  FORGET_PARTICIPANT_PASSWORD_ERROR,
} from "./actionTypes"

export const participantUserForgetPassword = (user, history) => {
  return {
    type: FORGET_PARTICIPANT_PASSWORD,
    payload: { user, history },
  }
}

export const participantUserForgetPasswordSuccess = message => {
  return {
    type: FORGET_PARTICIPANT_PASSWORD_SUCCESS,
    payload: message,
  }
}

export const participantUserForgetPasswordError = message => {
  return {
    type: FORGET_PARTICIPANT_PASSWORD_ERROR,
    payload: message,
  }
}
